import { FunctionalComponent, h } from "preact";
import { Route, Router, RouterOnChangeArgs } from "preact-router";

import Home from "../routes/home";
import Profile from "../routes/profile";
import Games from "../routes/games";
import Careers from "../routes/careers";
import News from "../routes/news";
import Contact from "../routes/contact";
import NotFoundPage from "../routes/notfound";
import Header from "./header";

const App: FunctionalComponent = () => {
    let currentUrl: string;
    const handleRoute = (e: RouterOnChangeArgs) => {
        currentUrl = e.url;
    };

    return (
        <div id="app">
            <Header />
            <Router onChange={handleRoute}>
                <Route path="/" component={Home} />
                <Route path="/profile/" component={Profile} user="me" />
                <Route path="/profile/:user" component={Profile} />
                <Route path="/games/:gameName" component={Games} />
                <Route path="/games/" component={Games} gameName="all" />
                <Route path="/careers/:job" component={Careers} />
                <Route path="/careers/" component={Careers} jobID="0" />
                <Route path="/news/:newsID" component={News} />
                <Route path="/news/" component={News} newsID="all"/>
                <Route path="/contact/" component={Contact} />
                <NotFoundPage default />
            </Router>
        </div>
    );
};

export default App;
